var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10904_32451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 51.1202C20.11 51.1202 15.44 50.1202 12.45 47.8102C11.31 46.9202 9.14002 48.5902 7.32002 46.1302C4.90002 42.8302 5.74 39.4602 7.42 38.5602C9.42 37.4902 11.16 39.7702 11.16 39.7702C8.15999 23.0502 15 12.7002 30 12.7002C45 12.7002 51.8099 23.0502 48.8499 39.7702C48.8499 39.7702 50.61 37.4902 52.59 38.5602C54.27 39.4602 55.11 42.8302 52.68 46.1302C50.87 48.5902 48.68 46.9202 47.55 47.8102C44.57 50.1602 39.9 51.1202 30 51.1202Z",
    fill: "#F6DAB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 12.71C45 12.71 51.8 23.0599 48.85 39.7799C47.08 37.5699 45.9401 35.78 45.5801 31.24C45.497 29.905 44.9802 28.6336 44.1084 27.6191C43.2366 26.6047 42.0573 25.9028 40.75 25.62C37.23 24.95 34.24 25.81 30 25.81C25.76 25.81 22.78 24.95 19.25 25.62C17.9445 25.9047 16.7676 26.6075 15.8977 27.6217C15.0278 28.636 14.5125 29.9063 14.43 31.24C14.07 35.82 12.93 37.5699 11.16 39.7799C8.21002 23.0699 15 12.71 30 12.71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22 12.2002L30.47 12.9602C30.41 14.1802 30.54 17.7302 30.09 18.0702C29.64 18.4102 28.87 18.0702 28.09 16.5702C27.5996 15.364 27.4307 14.0512 27.5999 12.7602C28.1533 12.6147 28.695 12.4275 29.22 12.2002Z",
    fill: "url(#paint0_linear_10904_32451)",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19006 4.79993L9.43005 8.68991C10.6595 10.2353 12.0886 11.6107 13.6801 12.7799C15.6101 13.9699 17.68 14.1599 19.05 15.2199C20.42 16.2799 23.24 19.5299 25.23 17.3099C27.22 15.0899 23.7201 14.3099 22.7201 13.4199C24.3581 13.4057 25.9878 13.1839 27.5701 12.7599C28.1336 12.6159 28.6853 12.4287 29.2201 12.1999L30.4701 12.9599L32.12 13.9599C32.12 13.9599 32.21 16.1099 32.24 17.1399C32.4402 18.1419 33.0163 19.0292 33.85 19.6199C34.5 20.1699 35.69 19.1699 35.62 18.7999C35.4866 17.0934 35.4432 15.381 35.49 13.6699C35.56 11.4499 33.11 10.2299 33.11 10.2299C30.5045 8.33873 27.5867 6.92047 24.49 6.03992C20.5745 4.79059 16.7291 3.33182 12.9701 1.66992",
    fill: "url(#paint1_linear_10904_32451)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19006 4.79993L9.43005 8.68991C10.6595 10.2353 12.0886 11.6107 13.6801 12.7799C15.6101 13.9699 17.68 14.1599 19.05 15.2199C20.42 16.2799 23.24 19.5299 25.23 17.3099C27.22 15.0899 23.7201 14.3099 22.7201 13.4199C24.3581 13.4057 25.9878 13.1839 27.5701 12.7599C28.1336 12.6159 28.6853 12.4287 29.2201 12.1999L30.4701 12.9599L32.12 13.9599C32.12 13.9599 32.21 16.1099 32.24 17.1399C32.4402 18.1419 33.0163 19.0292 33.85 19.6199C34.5 20.1699 35.69 19.1699 35.62 18.7999C35.4866 17.0934 35.4432 15.381 35.49 13.6699C35.56 11.4499 33.11 10.2299 33.11 10.2299C30.5045 8.33873 27.5867 6.92047 24.49 6.03992C20.5745 4.79059 16.7291 3.33182 12.9701 1.66992",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19006 4.7998L9.43005 8.68979C10.6595 10.2352 12.0886 11.6106 13.6801 12.7798C15.6101 13.9698 17.68 14.1598 19.05 15.2198C20.42 16.2798 23.24 19.5298 25.23 17.3098C27.22 15.0898 23.7201 14.3098 22.7201 13.4198C21.7201 12.5298 19.6301 11.2698 18.8301 9.90979",
    fill: "url(#paint2_linear_10904_32451)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19006 4.7998L9.43005 8.68979C10.6595 10.2352 12.0886 11.6106 13.6801 12.7798C15.6101 13.9698 17.68 14.1598 19.05 15.2198C20.42 16.2798 23.24 19.5298 25.23 17.3098C27.22 15.0898 23.7201 14.3098 22.7201 13.4198C21.7201 12.5298 19.6301 11.2698 18.8301 9.90979",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10904_32451",
    x1: 27.5099,
    y1: 15.2002,
    x2: 30.47,
    y2: 15.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DAB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68673"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10904_32451",
    x1: 3.19006,
    y1: 10.7299,
    x2: 35.62,
    y2: 10.7299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DAB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68673"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10904_32451",
    x1: 14.51,
    y1: 18.0698,
    x2: 14.51,
    y2: 4.7998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DAB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68673"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10904_32451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItching);
export default __webpack_public_path__ + "static/media/itching.92026df8d8dd15cfc3501bab234c7743.svg";
export { ForwardRef as ReactComponent };